import { useDeliveryData } from "@app/store/useDeliverySearchData";
import { ActionIcon, Box, Flex, TextInput, Title } from "@mantine/core";
import { generatePath, Link, useNavigate } from "react-router-dom";
import { Fragment } from "react/jsx-runtime";
import SelectionDelivery from "../../selection/Selection";
import OrderPatientList from "./OrderPatientList";
import "./styles.scss";
import { IconPencil } from "@tabler/icons-react";
import routes from "@app/config/routes";

const PatientOrderInformation = () => {
  const navigate = useNavigate();
  const { showDeliveryBy } = useDeliveryData((state) => state.dataDispense);

  const { dataPatient: patientData } = useDeliveryData((state) => state.dataToSearch);

  const searchSection = () => {
    return (
      <>
        <div className="searchSection" data-testid="patientorderinfo-search-section">
          <Box>
            <Box px={"lg"} pt={"xl"} mt={"sm"} pb={"xs"} className="">
              <div
                className="flex items-center pointer"
                data-testid="patientorderinfo-back-button"
                onClick={() => navigate(-1)}
              ></div>
              <Title size={"h3"} py={"xs"} c="secondary-color" fw={"bold"} ta={"center"}>
                Buscar ordenamiento
              </Title>
            </Box>
            <Flex justify="end" px="lg">
              <ActionIcon
                variant="subtle"
                size="lg"
                component={Link}
                to={generatePath(routes.getPatientOrderInformationEdit, {
                  patientId: patientData?.id || ""
                })}
                data-testid="patientorderinfo-edit-button"
              >
                <IconPencil style={{ width: 25, height: 25 }} />
              </ActionIcon>
            </Flex>
            <Box px={"lg"} data-testid="patientorderinfo-patient-fields">
              <div className="">
                <TextInput
                  label="Identificación del paciente"
                  placeholder="Escribir..."
                  value={`${patientData?.docTypeDesc ?? ""} ${patientData?.document ?? ""}`.trim()}
                  disabled
                  data-testid="patientorderinfo-patient-id"
                />
                <TextInput
                  label="Primer Nombre"
                  placeholder="Escribir..."
                  value={patientData?.first_name}
                  disabled
                  data-testid="patientorderinfo-first-name"
                />
                <TextInput
                  label="Primer apellido"
                  value={patientData?.last_name}
                  placeholder="Seleccionar..."
                  disabled
                  data-testid="patientorderinfo-last-name"
                />
                <TextInput
                  label="Fecha de nacimiento"
                  type="date"
                  placeholder="Escribir..."
                  value={patientData?.birth_date}
                  disabled
                  data-testid="patientorderinfo-birth-date"
                />
                <TextInput
                  label="Whatsapp"
                  value={patientData?.whatsapp}
                  placeholder="Escribir..."
                  disabled
                  data-testid="patientorderinfo-whatsapp"
                />
                <TextInput
                  label="Correo"
                  value={patientData?.email}
                  placeholder="Escribir..."
                  disabled
                  data-testid="patientorderinfo-email"
                />
              </div>
            </Box>
          </Box>
        </div>
      </>
    );
  };

  const renderComponent = () => {
    return (
      <Fragment>
        <div className="bodyOrder" data-testid="patientorderinfo-body">
          {searchSection()}

          {showDeliveryBy ? (
            <SelectionDelivery />
          ) : (
            <div className="renderSection" data-testid="patientorderinfo-order-list">
              <OrderPatientList />
            </div>
          )}
        </div>
      </Fragment>
    );
  };

  return renderComponent();
};

export default PatientOrderInformation;
